import classnames from 'classnames';

import { CostReviewLineItemRecommendation } from './cost-review-line-item-recommendation';
import style from './cost-review-line-item-with-recommendation.module.less';
import FormattedCurrencyContainer from '../../formatted-currency/container';
import { CostReviewLine } from '../cost-review-line-item-service/cost-review-line';

/**
 * @param {object} props
 * @param {boolean} props.isRecommendationSelected
 * @param {string|React.ReactNode} props.originalServiceName
 * @param {boolean} props.isToggleRecommendationDisabled
 * @param {import('../../../prop-types/cost-review.types').CostReviewRecommendation} props.recommendation
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @param {number} props.originalServiceCost
 * @param {string} [props.originalServiceCurrencyCode]
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemWithRecommendation = ({
  isRecommendationSelected,
  originalServiceName,
  isToggleRecommendationDisabled,
  recommendation,
  onToggleRecommendation,
  originalServiceCost,
  originalServiceCurrencyCode,
}) => {
  return (
    <CostReviewLine
      className={classnames({
        [style['has-applicable-recommendation']]: recommendation && !isRecommendationSelected,
      })}
    >
      {originalServiceName}
      <div className={style['recommendation-and-cost']}>
        <CostReviewLineItemRecommendation
          isRecommendationSelected={isRecommendationSelected}
          isToggleRecommendationDisabled={isToggleRecommendationDisabled}
          onToggleRecommendation={onToggleRecommendation}
          recommendation={recommendation}
        />
        <div className={style['original-cost']}>
          <FormattedCurrencyContainer currencyCode={originalServiceCurrencyCode} value={originalServiceCost} />
        </div>
      </div>
    </CostReviewLine>
  );
};
